define('v3/Common/Helpers/SharedDependenciesContainer/SharedDepdendenciesContainer',[
	'knockout',
	'jquery',
	'lodash',
	'v3/Common/Models/enums',
	'env'
], function (ko, $, _, commonEnums, env) {
	return new function () {
		return {
			ko: ko,
			$: $,
			_: _,
			commonEnums: commonEnums,
			env: env
		};
	}();
});
